module.exports = __webpack_public_path__ + "static/img/talent.2b40bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/talent.png
// module id = jwlS
// module chunks = 0